import { render, staticRenderFns } from "./RemolqueIndex.vue?vue&type=template&id=dd7dbd82"
import script from "./RemolqueIndex.vue?vue&type=script&lang=js"
export * from "./RemolqueIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports